/**
 * Axios configuration for Dealer's Publisher API
 * @module PublishersAPI
 *
 * This a private API in the dealerappcenter organization
 * The purpose is to retrieve vehicle's information like Vehicle Shares or lists of vehicles
 */
import Store from '@/store';
import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/v1`,
  params: {
    token: process.env.VUE_APP_TOKEN,
  },
});

instance.interceptors.request.use(function addRooftopIdHeader(config) {
  return {
    ...config,
    headers: {
      ...config.headers,
      'Rooftop-Id': Store.state.leadInfo.companies_id,
    },
  };
});

export default instance;
